import { observer } from "mobx-react";
import { useEstimateEditorSettings, useEstimateStructure, useUserVisibleWorkTypes } from "@tools";
import { Collapse, Grid } from "@material-ui/core";
import { TimelineUtilizationCells } from "../../TimelineCells";
import useStyle from "./TimelineUtilizationContents.style";

export const TimelineUtilizationContents = observer(() => {
  const classes = useStyle();
  const { isProposal, blockExpansions } = useEstimateEditorSettings();
  const structure = useEstimateStructure();

  const { timelineWorkTypes } = structure;

  const workTypes = useUserVisibleWorkTypes(timelineWorkTypes, isProposal, true);


  return (
    workTypes.map((workType) => {
      const expanded = workType.displayTimelineResources?.length > 0 && (workType.isTimelineOpened || blockExpansions);
      const handleExpand = () => workType.setTimelineOpenState(!workType.isTimelineOpened);
      return <Grid
        key={workType.id}
        item container
        direction="column"
        style={{ opacity: workType.turnOff ? 0.3 : undefined }}
      >
        <div className={classes.utilizationRow}>
          <TimelineUtilizationCells
            workTypeId={workType.id}
            color={workType.timelineColor}
            fontColor={workType.timelineFontColor}
            name={workType.name}
            expandable={Boolean(workType.displayTimelineResources?.length)}
            expanded={expanded}
            onExpand={handleExpand}
          />
        </div>
        <Collapse in={expanded} mountOnEnter unmountOnExit>
          {(workType.displayTimelineResources || []).map((member) => (
            <div key={member.id} className={classes.utilizationMemberRow}>
              <TimelineUtilizationCells
                workTypeId={workType.id.toString()}
                teamMemberId={member.id}
                color={member.timelineColor}
                fontColor={member.timelineFontColor}
                name={member.name}
              />
            </div>
          ))}
        </Collapse>
      </Grid>;
    })
  );
});